















































import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { BaseFlowButtonWithOutput } from '../../../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/FlowButtons/BaseFlowButtonWithOutput'
import { SELF_NODE_ITEM } from '../../../../../../../../../components/Socket/SocketsHelper'
import CustomEditor from '../../../../../../../../Editor/CustomEditor'
import ActionNodeAction from '../../../../../../Action/logic/Actions'
import { LabelsAction } from '../../../../../../Action/logic/Actions/LabelsAction/LabelsAction'
import { NotifyGroupAction } from '../../../../../../Action/logic/Actions/NotifyGroupAction/NotifyGroupAction'
import { NotifyUsersAction } from '../../../../../../Action/logic/Actions/NotifyUsersAction/NotifyUsersAction'
import { PropertyAction } from '../../../../../../Action/logic/Actions/PropertyAction/PropertyAction'
import { getActionNodeActionsIcons } from '../../../../../../Action/logic/utils'
import LabelsValues from './LabelsValues.vue'
import NotifyUsersValues from './NotifyActionValues.vue'
import PropertyValue from './PropertyValue.vue'

@Component({
  components: {
    LabelsValues,
    NotifyUsersValues,
    PropertyValue,
  },
  data() {
    return {
      getActionNodeActionsIcons,
      LabelsAction,
      NotifyUsersAction,
      NotifyGroupAction,
      PropertyAction,
      snakeCase,
      SELF_NODE_ITEM
    }
  },
})
export default class ActionDescriptions extends Vue {
  @Prop() actions!: Array<ActionNodeAction>

  @Prop() i18n!: i18n

  @Prop() editor!: CustomEditor

  @Prop() properties!: Array<GroupedBotProperty>

  @Prop() getLabels!: () => { [key: string]: string }

  mouseEnterHandler(action: ActionNodeAction): void {
    if ((action instanceof NotifyUsersAction || action instanceof NotifyGroupAction) && action.variants.length) {
      const buttons: Array<number> = []

      action.variants[0].buttons.forEach((r) => r.forEach((b) => {
        if (b instanceof BaseFlowButtonWithOutput && b.output) {
          buttons.push(b.output)
        }
      }))

      this.setSelectedActionButtons(buttons)
    }
  }

  mouseLeaveHandler(): void {
    this.setSelectedActionButtons([])
  }

  @Emit()
  setSelectedActionButtons(buttons: Array<number>): Array<number> {
    return buttons
  }
}
